module.exports = __webpack_public_path__ + "media/images/features/5/history-1-1-144a726955c9874b33e0af3aabc7607f.jpg";